// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../../vue-api'
import { ImageProps } from '../../../atoms/Image'

import { VideoProps } from '../Video.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const videoProps: ComponentObjectPropsOptions<VideoProps> = {
  /**
   * @see VideoProps.autoplay
   */
  autoplay: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @see VideoProps.isMuted
   */
  isMuted: {
    type: Boolean,
    required: false,
    default: true
  },

  /**
   * @see VideoProps.isPlaying
   */
  isPlaying: {
    type: Boolean,
    required: false,
    default: false
  },

  ratio: {
    type: String,
    required: false,
    default: '16-9'
  },

  /**
   * @see VideoProps.source
   */
  source: {
    type: String,
    required: true
  },

  /**
   * @see VideoProps.showControls
   */
  showControls: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @see VideoProps.coverImage
   */
  thumbnail: {
    type: Object as PropType<ImageProps>,
    required: false,
    default: () => ({})
  }
}
